import {
	ToothRestoration,
	ToothRestorationType,
} from '../../../../graphql/graphql';
import getHistoryValueSurfaces from './getHistoryValueSurfaces';
import useTranslation from '../../../../Hooks/useTranslation';
import parseSimpleRestorationValue from './parseSimpleRestorationValue';

const TOOTH_RESTORATION_TYPE: Record<ToothRestorationType, string> = {
	[ToothRestorationType.Crown]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.crown',
	[ToothRestorationType.Filling]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.filling',
	[ToothRestorationType.Inlay]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.inlay',
	[ToothRestorationType.Onlay]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.onlay',
	[ToothRestorationType.Veneer]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.veneer',
	[ToothRestorationType.PartialCrown]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.partialCrown',
};

export default function getHistoryValueRestoration(value: ToothRestoration) {
	const { t } = useTranslation();
	const resultArray: string[] = [];

	const { type, surfaces, createdAt, ...simpleValues } = value;

	if (type) {
		resultArray.push(t(TOOTH_RESTORATION_TYPE[type]));
	}

	if (surfaces?.length) {
		resultArray.push(getHistoryValueSurfaces(surfaces));
	}

	Object.entries(simpleValues).forEach(([key, value]) =>
		resultArray.push(parseSimpleRestorationValue(key, value)),
	);

	return resultArray.filter(Boolean).join(' - ');
}
